const LOCALES = {
  EN: "en",
  ZH: "zh_tw",
}

export default LOCALES
